import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Grid,
  Container,
  Divider,
  Stack,
  CircularProgress,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import apiClient from "../../api/apiClient";
import DashboardCard from "../../components/DashboardCard";
import EventIcon from "@mui/icons-material/Event";
import PeopleIcon from "@mui/icons-material/People";
import AssignmentIcon from "@mui/icons-material/Assignment";
import NumberCircle from "../../components/NumberCircle";
const Dashboard = () => {
  const [totalEvents, setTotalEvents] = useState(0);
  const [totalRegistrations, setTotalRegistrations] = useState(0);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchDashboardData = async () => {
      try {
        const [eventsResponse, registrationsResponse] = await Promise.all([
          apiClient.get("/events/count/event"),
          apiClient.get("/registrations/count"),
        ]);
        console.log(eventsResponse);
        setTotalEvents(eventsResponse.data.totalEvents);
        setTotalRegistrations(registrationsResponse.data.totalRegistrations);
      } catch (error) {
        console.error("Error fetching dashboard data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchDashboardData();
  }, []);

  if (loading) {
    return (
      <Box
        sx={{
          minHeight: "calc(100vh - 120px)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Container maxWidth="lg" sx={{ mt: 6, mb: 6 }}>
      {/* Heading Section */}
      <Box sx={{ mb: 2 }}>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems={{ xs: "flex-start", sm: "center" }}
          flexWrap="wrap"
          rowGap={2}
        >
          <Box>
            <Typography variant="h4" fontWeight="bold">
              Admin Dashboard
            </Typography>
            <Typography variant="body1" color="text.secondary">
              View your event and registration statistics, manage events, and
              get an overview of your platform activity.
            </Typography>
          </Box>
        </Stack>

        <Divider sx={{ mt: 3 }} />
      </Box>

      {/* dashboard Navigation Cards */}
      <Grid
        container
        spacing={3}
        justifyContent={{ xs: "center", sm: "flex-start" }}
        sx={{ mt: 1 }}
      >
        <DashboardCard
          title="Manage Events"
          description="Create, manage, and view details of your events."
          buttonLabel="Manage Events"
          icon={<AssignmentIcon />}
          color="#1976d2"
          route="/events"
        />

        <DashboardCard
          title="Total Events"
          description="Total number of events created and managed by you."
          buttonLabel={null}
          icon={<EventIcon />}
          color="#009688"
          route={null}
          actions={<NumberCircle number={totalEvents} color="#009688" />}
        />

        <DashboardCard
          title="Total Registrations"
          description="Total number of attendees registered across all your events."
          buttonLabel={null}
          icon={<PeopleIcon />}
          color="#4caf50"
          route={null}
          actions={<NumberCircle number={totalRegistrations} color="#4caf50" />}
        />
      </Grid>
    </Container>
  );
};

export default Dashboard;
